<template>
	<svg :height="radius * 2" :width="radius * 2">
		<circle stroke="white" fill="none"
			r="1" cx="0" cy="0" />
		<circle class="transitionCircle" stroke="#3ba755" :stroke-dasharray="circumference + ' ' + circumference"
			:style="{ strokeDashoffset: strokeDashoffset }" :stroke-width="stroke" fill="none"
			:r="normalizedRadius" :cx="radius" :cy="radius" />
	</svg>
</template>
<script>
	export default {
		props: {
			radius: Number,
			progress: Number,
			stroke: Number
		},
		data() {
			const normalizedRadius = this.radius - this.stroke * 2;
			const circumference = normalizedRadius * 2 * Math.PI;

			return {
				normalizedRadius,
				circumference
			};
		},
		computed: {
			strokeDashoffset() {
				return this.circumference - this.progress / 100 * this.circumference;
			}
		},
	}

</script>
<style scoped>
.transitionCircle {
	transition: stroke-dashoffset 850ms ease-in-out;
}
</style>
